var Scinet = Scinet || {};

Scinet.busy = {
    lockOptions: {
        centerY: false,
        centerX: false,
        css: {
            position: "fixed",
            top: "50%", 
            left: "50%",
            "margin-right": "-50%",
            transform: "translate(-50%, -50%)",
            border: "0px",
            backgroundColor: ""
        },
        overlayCSS: {
            backgroundColor: "#000",
            opacity: 0
        }
    },
    lock: function () {
        var me = Scinet.busy;
        if ($.blockUI) {
            var lockOptions = me.lockOptions;
            lockOptions.message = "<span class='busy-icon'></span>";

            $.blockUI(lockOptions);
        }
    },
    unlock: function () {
        $.unblockUI();
    }
}
